import Vue from '@/setup'
import tippy from 'tippy.js'

import OvpIcon from '@/components/Container/Icon'
// Create a vue icon component
const IconComponent = Vue.extend(OvpIcon)

/**
 * @param title
 * @returns {Element}
 */
export const renderIcon = content => {
  // Create a new icon element
  const icon = new IconComponent({
    propsData: {
      art: 'light',
      name: 'circle-question',
    },
  })
  icon.$mount()

  tippy(icon.$el, {
    appendTo: document.body,
    arrow: true,
    allowHTML: true,
    interactive: true,
    theme: 'material',
    content,
  })

  return icon.$el
}
